module.exports = __webpack_public_path__ + "img/imagen_donaciones_cabezote.76afe3a1.jpg";